/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmissionOriginSchema
 */
export interface SubmissionOriginSchema {
    /**
     * 
     */
    messageSid: string | null;
    /**
     * 
     */
    batchId: string | null;
    /**
     * 
     */
    index: number;
}

/**
 * Check if a given object implements the SubmissionOriginSchema interface.
 */
export function instanceOfSubmissionOriginSchema(value: object): value is SubmissionOriginSchema {
    if ((!('messageSid' in (value as Record<string, any>)) && !('message_sid' in (value as Record<string, any>))) || ((value as Record<string, any>)['messageSid'] === undefined && (value as Record<string, any>)['message_sid'] === undefined)) return false;
    if ((!('batchId' in (value as Record<string, any>)) && !('batch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['batchId'] === undefined && (value as Record<string, any>)['batch_id'] === undefined)) return false;
    if (!('index' in value) || value['index'] === undefined) return false;
    return true;
}

export function SubmissionOriginSchemaFromJSON(json: any): SubmissionOriginSchema {
    return SubmissionOriginSchemaFromJSONTyped(json, false);
}

export function SubmissionOriginSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionOriginSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'messageSid': json['message_sid'],
        'batchId': json['batch_id'],
        'index': json['index'],
    };
}

export function SubmissionOriginSchemaToJSON(json: any): SubmissionOriginSchema {
    return SubmissionOriginSchemaToJSONTyped(json, false);
}

export function SubmissionOriginSchemaToJSONTyped(value?: SubmissionOriginSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_sid': value['messageSid'],
        'batch_id': value['batchId'],
        'index': value['index'],
    };
}

